export default "__VITE_ASSET__DKYVJFia__"